export const appendWarning = (warning: string) => (array: string[] | undefined) =>
  (array ?? []).concat(warning)
